import script from "./ResearcherManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearcherManagement.vue?vue&type=script&setup=true&lang=js"

import "./ResearcherManagement.vue?vue&type=style&index=0&id=5399844f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5399844f"]])

export default __exports__